import React, { Component } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from "@mui/material/TextField";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TreeView from 'devextreme-react/tree-view';
import AssetItem from './AssetItem.js';
import { getToken, getRoles, getUsername } from './TokenController';
import { variables } from "./Variables.js"
import ContextMenu from 'devextreme-react/context-menu'
import Backend from './backend.js'
import ClipLoader from "react-spinners/ClipLoader";
import AssetList from './AssetList.js';
import { assetCreator } from "./index.js"

import FileDropUploader from './components/FileUploader.jsx'
export default class TreeA extends React.Component {
    
    constructor(props) {
        super(props);
        this.contextMenuRef = React.createRef();
        this.state = {
            selectedNode: {},
            selectedId: "",
            selectedKey :'',
            name: "",
            assetTypes: [],
            selectNodesRecursive: true,
            selectByClick: true,
            showCheckBoxesMode: "none",
            selectionMode: "single",
            isSelectionModeDisabled: false,
            isRecursiveDisabled: false,
            openModal: false,
            openModalMulti: false,
            assettype: "",
            preferedName: "",
            description: "",
            showDetails: false,
            showAssetsBelow: false,
            itemCanEdit: false,
            antal: "",
            ansvarig: "",
            area: "MECH",
            loading: false,
           

        };;
        this.backend = new Backend()
        this.assetTypes = [];
        this.menuItems = [
            { id: 'addmech', text: 'Add Object object' },
        //    {id: 'el', text: 'Add electrical object' },
            //{ id: 'instru', text: 'Add instrumentation' },
         //   { id: 'efunc', text: 'Add electrical function' },
         //   { id: 'reserve', text: 'Reserve objects' },
         //   { id: 'excel', text: 'Export to Excel' },
         //   { id: 'remove', text: 'Remove' }
        ];

        this._child = React.createRef();
        this._child2 = React.createRef();
        this.tokenRef = React.createRef();
        this.treeViewRef = React.createRef();
        this.treeViewSelectionChanged = this.treeViewSelectionChanged.bind(this);
        this.selectByClickValueChanged = this.selectByClickValueChanged.bind(this);
        this.style = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)', 
            width: '90%',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            
        };
        this.expandToItem= '';
        
        this.token = '';

        this.claims = [];

        
       
    }

    async getTokenlocal() {
        this.token = await getToken();
        console.log(this.token);
        return this.token;   
    }

   

    async getAssetTypes() {
        console.log('Change area }' + this.state.area)
        this.token = await getToken();
        fetch(`${variables.API_URL}/api/assets/assettypes?area=${this.state.area}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
            }

        })
            .then((response) => response.json()).then(data => {
                this.setState({ assetTypes: data }); 
            })
            .catch(() => { throw new Error('Data Loading Error'); });
    }

    setPName(name) {
        this.setState({ preferedName: name })
    }

    getPreferedName(assettype, parent) {
        var area = "MECH";

        assetCreator.getPreferedName(assettype, parent, area).then((response) => response.json()).then(data => this.setState({ preferedName: data.id }))
            .catch(() => { throw new Error('Data Loading Error'); })
        
        
       

        /*
       this.token = await getToken();
       console.log(this.state.area);
       fetch(`${variables.API_URL}/api/assets/name?parentId=${parent}&assettype=${assettype}&area=${this.state.area}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
            }

            })
            .then((response) => response.json()).then(data => this.setState({ preferedName: data.id }))
            .catch(() => { throw new Error('Data Loading Error'); });
            */
    }

    async createChildren(parent) {
       
        this.token = await getToken();
        const parentId = parent ? parent.itemData.id : '';

        console.log(this.token);
        return fetch(`${variables.API_URL}/api/assets?parent=${parentId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,              
            }

        })
            .then((response) => response.json())
            .catch(() => { throw new Error('Data Loading Error'); });

        
     
    }
    treeViewSelectionChanged(e) {
        console.log(e);
        this.syncSelection(e.component);
    }

   

    async syncSelection(treeView) {
        this.token = await getToken()
        console.log(this.claims.roles)
        const selectedNodes = treeView.getSelectedNodes()
            .map((node) => node.itemData);
        if (selectedNodes.length > 0) {


            if ((selectedNodes[0].id.charAt(0) === 'Q' && selectedNodes[0].id.length === 2) || selectedNodes[0].id.charAt(0) !== 'Q')  {
                this.setState(() => ({ showAssetsBelow: true, showDetails: false, name: selectedNodes[0].text, selectedId: selectedNodes[0].id, selectedNodes, selectedKey: selectedNodes[0].key }));

                if (this.claims.length == 0) {
                    this.claims = getRoles(this.token);
                }
                console.log(this.claims.roles);
                var canEdit = this.canEditNode(selectedNodes[0].id);

                console.log('Token ' + this.token);
                this._child2.current.setNewId(selectedNodes[0].id, this.token);
            }
            else {

                this.setState(() => ({ showAssetsBelow: false, showDetails: true, name: selectedNodes[0].text, selectedId: selectedNodes[0].id, selectedNodes, selectedKey: selectedNodes[0].key }));

                if (this.claims.length == 0) {
                    this.claims = getRoles(this.token);
                }
                console.log(this.claims.roles);
                var canEdit = this.canEditNode(selectedNodes[0].id);

                console.log('Can eidt ' + canEdit);
                this._child.current.setNewId(selectedNodes[0].id, selectedNodes[0].text, this.token, canEdit);
            }

            
        }
        else {
            this.setState(() => ({ name: "", selectedNodes, showDetails:false }));
           
        }
    }

    canEditNode(node) {
        var canEdit = false;
        console.log("Can edit " + node )
        if (this.claims.roles.includes('ADMIN') || this.claims.roles.includes('LOCALADMIN.' + node.substr(0, 1))) {
            canEdit = true;
            console.log("Can edit true")
        }
        else if (node.substr(0, 1) == "V") {
            if (this.claims.roles.includes('LOCALADMIN.' + node.substr(2, 1))) {
                canEdit = true
            }
        }
        this.setState({ itemCanEdit: canEdit });
        return canEdit;
    }

    showCheckBoxesModeValueChanged(e) {
        const state = { showCheckBoxesMode: e.value };

        if (e.value === 'selectAll') {
            state.selectionMode = 'multiple';
            state.isRecursiveDisabled = false;
        }
        state.isSelectionModeDisabled = e.value === 'selectAll';

        this.setState(state);
    }

    selectionModeValueChanged(e) {
        const state = { selectionMode: e.value };

        if (e.value === 'single') {
            state.selectNodesRecursive = false;
            this.treeView.unselectAll();
        }
        state.isRecursiveDisabled = e.value === 'single';
        
        this.setState(state);
    }

    selectNodesRecursiveValueChanged(e) {
        this.setState({ selectNodesRecursive: e.value });
    }

    selectByClickValueChanged(e) {
        this.setState({ selectByClick: e.value });
    }

    get treeView() {
        return this.treeViewRef.current.instance;
    }

    handleChange = (event) => {
        this.setState({ assettype: event.target.value });
        this.getPreferedName(event.target.value, this.state.selectedId);
    };
    handleChangeMulti = (event) => {
        console.log(event.target.value);
        this.setState({ assettype: event.target.value });
       
    };

    handleChangeArea = (event) => {
        console.log(event.target.value);
        this.setState({ area: event.target.value });
        this.getAssetTypes();


    };

    handleClose = () => {
    
        this.setState({ openModal: false });
    }
    handleCloseMulti = () => {
       
        this.setState({ openModalMulti: false });
        console.log(this.assetTypes)
    }
  


    handleDescChange = (event) => {
        // 👇️ update textarea value
        this.setState({ description: event.target.value });
        console.log(event.target.value);
    };

    handleIDChange = (event) => {       
        this.setState({ preferedName: event.target.value });
        console.log(event.target.value);
    }

    handleCountChange = (event) => {
        this.setState({ antal: event.target.value });
    }

    handleRespChange = (e) => {
    this.setState({ ansvarig: e.target.value })
    }

    async exportToExcel ()  {
        this.setState({ loading: true })
        this.token = await getToken();
        console.log('Exports ' + this.token);
        this.backend.exportToExcel(this.token,this.state.selectedId, this.downloadFile)
    }

    downloadFile = (blob) => {
        this.setState({ loading: false })
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'export.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    commitMulti = (event) => {
        fetch(`${variables.API_URL}/api/assets/getmulti?parentid=${this.state.selectedId}&assettyp=${this.state.assettype}&cnt=${this.state.antal}&responsible=${this.state.ansvarig}&area=${this.state.area}`,
            {

                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'responseType': 'arraybuffer',
                    'Authorization': 'Bearer ' + this.token,
                }

            }

        ).then(function (response) {
            return response.blob();
        }
        )
            .then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', 'reservd_assets.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.setState({ openModal: false });
                this.expandToItem = this.state.selectedId.substr(0, 3);

                this.setState({
                    selectedId: '',
                    preferedName: '',
                    assettype: '',
                    text: '',
                    area:''
                });

                this.refresh(null);
            })
            .catch((e) => { console.error(e) });

    }


    commit = (event) => {

        const body = {
            parentId:this.state.selectedId,
            id:this.state.preferedName,
            assettype:this.state.assettype,
            text: this.state.description,
            responsible: getUsername()
        }
        fetch(`${variables.API_URL}/api/assets/`,
            {

                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.token,
                },
                body: JSON.stringify(body)
            }

        )
            .then(
                (response) => response.json()
        ).
            then((data) => {
                this.setState({ openModal: false });
                if (this.state.selectedId.substr(0, 2) == "V.") {
                    this.expandToItem = this.state.selectedId.substr(2, 3);
                }
                else {
                    this.expandToItem = this.state.selectedId.substr(0, 3);
                }
                

                this.setState({
                    selectedId: '',
                    preferedName: '',
                    assettype: '',
                    text: ''
                });

                this.refresh(null);

                
               
            })
            .catch((e) => { console.error(e) });





    }

    exapndtoNewNode = (id) => {
        if (this.state.selectedId.substr(0, 2) == "V.") {
            this.expandToItem = this.state.selectedId.substr(2, 3);
        }
        else {
            this.expandToItem = this.state.selectedId.substr(0, 3);
        }
        this.refresh(null);

    }

    onItemExpanded = (e) => {
        console.log('Expand ' + e.itemData.id);
        console.log('Expand to ' + this.expandToItem);
        if (e.itemData.id != this.expandToItem) {

            var antaTkn = e.itemData.id.length;
            if (e.itemData.id == 'V') {
                antaTkn = 0;
            }

            this.treeView.expandItem(this.expandToItem.substr(0, antaTkn + 1));
        }
    }

    

    meny = (e) => {
        // e.preventDefault();
        this.setState({ selectedId: e.itemData.id })
        console.log(e.itemData.id);

        const isBlock = e.itemData.id.length < 3 ;
        this.contextMenuRef.current.instance.option('items[0].visible', !isBlock);
        this.contextMenuRef.current.instance.option('items[1].visible', !isBlock);
        this.contextMenuRef.current.instance.option('items[2].visible', !isBlock);
        this.contextMenuRef.current.instance.option('items[3].visible', true);
        this.contextMenuRef.current.instance.option('items[4].visible', true);
       


    }

    openfromOtherView(id) {
        console.log("Open from other view");
    }

    contextMenuItemClick = (e) => {
        let logEntry = '';
       
        console.log(this.state.selectedId)

        if (this.state.itemCanEdit) {
            

            switch (e.itemData.id) {
                case 'addmech': {

                    this.setState({
                        area: "MECH",
                        openModal: true
                    });

                    break;
                }
                case 'el': {
                    this.setState({
                        area: "EL",
                        openModal: true
                    });
                    break;
                }
                case 'efunc': {
                    this.setState({
                        area: "EFUNC",
                        openModal: true,
                        preferedName: this.state.selectedId + "-"
                    });
                    break;
                }
                case 'instru': {
                    this.setState({
                        area: "INST",
                        openModal: true
                    });
                    break;
                }
                case 'reserve': {
                    console.log('Open multi')
                    this.setState({
                        openModalMulti: true
                    });
                    break;
                }
                case 'excel': {
                    console.log('Export to Excel')
                    this.exportToExcel()
                }
                default:
                    break;
            }
            this.getAssetTypes();
            //  logEntry = `The '${this.state.selectedTreeItem.text}' group was expanded`;
            this.treeView.expandItem(this.state.selectedId);
        }
    }
    onItemCollapsed = (e) => {
        console.log('item collapsed' + e.itemData.id);
      //  if (e.itemData.id == 'Viscaria' && this.expandToItem.length > 1) {
      //      this.treeView.expandItem('V');
      //  }
    }

    setMenu = (e) => {
        console.log( e)
    }

    expandRoot = () => {
        this.treeView.expandItem(this.expandToItem.substr(0,1));
    }

    refresh = (event) => {
        console.log('Refresh')
        
        var rootNode = this.treeView.option("items[0]");
        this.setState({ showDetails: false });
        this.treeView.option("items", [rootNode]);  

      

        setTimeout(this.expandRoot, 400);
    }

   
    render() {
        return (
            <div>                
                <div className="form">
                    <h4>Assets</h4>                    
                    <TreeView
                        id="treeview"
                        dataStructure="plain"
                        rootValue=""
                        //  items={this.state.assets}
                        ref={this.treeViewRef}
                        //  items={this.childs}
                        height={'auto'}
                        width={450}
                        selectNodesRecursive={false}
                        selectByClick={this.state.selectByClick}
                        showCheckBoxesMode={this.state.showCheckBoxesMode}
                        selectionMode={this.state.selectionMode}
                        onSelectionChanged={this.treeViewSelectionChanged}
                        createChildren={this.createChildren}
                        onItemExpanded={this.onItemExpanded}
                        onItemCollapsed={this.onItemCollapsed}
                        onItemContextMenu={this.meny}
                    />
                    <ContextMenu
                        ref={this.contextMenuRef}
                        dataSource={this.menuItems}
                        target="#treeview .dx-treeview-item"
                        onItemClick={this.contextMenuItemClick}
                        value={this.state.area}
                    />
                    <ClipLoader
                        color={"#FFFF00"}
                        loading={this.state.loading}
                        size={150}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                    <div className={this.state.showDetails ? "selected-container" :'hidden'}>Selected Asset
                        
                        <div className='divGrid'>                            
                            <AssetItem  id="aab" ref={this._child} />
                        </div>
                       
                      
                    </div >

                    <div className={this.state.showAssetsBelow ? "selected-container" : 'hidden'}>Selected Asset

                        <div className='divGrid'>
                            <AssetList onCallback={this.exapndtoNewNode} id="aaa" ref={this._child2} />
                        </div>


                    </div >

                </div>

                <Modal
                    open={this.state.openModal}
                    onClose={this.handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={this.style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Add a new child Asset to {this.state.name}
                        </Typography>
                        <InputLabel id="demo-simple-select-label">Asset type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={this.state.assettype}
                            label="Asset type"
                            onChange={this.handleChange}
                        >
                            {this.state.assetTypes.map((item) => (
                                <MenuItem key={"mi" +item.assetTypeId} value={item.assetTypeId}>{item.assetTypeId + " " + item.nameSwe}</MenuItem>
                                ))} 
                        </Select>
                        <TextField value={this.state.preferedName} label="next Id" variant="outlined" onChange={this.handleIDChange } />
                        <TextField value={this.state.description} label="Description" onChange={this.handleDescChange} variant="outlined" />
                        <Button onClick={this.commit}  >Add</Button>
                    </Box>
                </Modal>

                <Modal
                    open={this.state.openModalMulti}
                    onClose={this.handleCloseMulti}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={this.style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Add multiple Asset to {this.state.name}
                        </Typography>
                        <InputLabel id="demo-simple-select-label">Asset type</InputLabel>
                        <Select id="areaSelect" label="Tech area" value={this.state.area} onChange={this.handleChangeArea}>
                            <MenuItem key="selMECH" value="MECH">Mechanical</MenuItem>
                            <MenuItem key="selEL" value="EL">Electrical</MenuItem>
                            <MenuItem key="selINST" value="INST">Instrumentation</MenuItem>                            
                        </Select>
                        <Select
                            labelId="demo-simple-select-label"
                            id="assettypemulti-list"
                            value={this.state.assettype}
                            label="Asset type"
                            onChange={this.handleChangeMulti}
                        >
                            
                            {this.state.assetTypes.map((item) => (
                                <MenuItem key={"mim" + item.assetTypeId} value={item.assetTypeId}>{item.assetTypeId + " " + item.nameSwe}</MenuItem>
                            ))}
                        </Select>
                        <TextField label="count" value={this.state.antal} onChange={this.handleCountChange} variant="outlined" />
                        <TextField label="Responsible" value={this.state.ansvarig} onChange={this.handleRespChange} variant="outlined" />
                        <Button onClick={this.commitMulti}  >Add</Button>
                    </Box>
                </Modal>              
               
            </div>
           
        );
            
        

    }

}